import api from '~/libs/api';
import { errorMessages } from '~/constants/errorMessages.ts';
import { useQuery } from '@tanstack/react-query';
import { TNewKvedResponse } from '~/queries/types.ts';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { useMemo } from 'react';

const getKved = () => async () => {
  try {
    const { data } = await api.get(`/dictionary-service/kved`);
    return data;
  } catch {
    throw Error(errorMessages.SERVICE_UNAVAILABLE);
  }
};

export const useNewKvedQuery = () => {
  const { data, error, isLoading, isError } = useQuery<TNewKvedResponse>({
    queryKey: ['kved'],
    queryFn: getKved(),
    staleTime: 30 * 60 * 1000,
  });

  const kveds: TAutocompleteOption[] = useMemo(() => {
    if (!data) return [];
    return data
      .map((kved) => ({
        value: kved.id.toString(),
        label: `${kved.code} - ${kved.name}`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [data]);

  return {
    kveds,
    rowKveds: data,
    error,
    isLoading,
    isError,
  };
};
